/* LIFEITALY theme 2.0. Vanilla JS, no dependencies. */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function isRtl(el) { return getComputedStyle(el || document.documentElement).direction === 'rtl'; }

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function safeStorage(type) {
    try { return window[type]; } catch (e) { return null; }
  }
  function storageGet(type, key) {
    try { var s = safeStorage(type); return s ? s.getItem(key) : null; } catch (e) { return null; }
  }
  function storageSet(type, key, val) {
    try { var s = safeStorage(type); if (s) s.setItem(key, val); } catch (e) { /* ignore */ }
  }

  /* ------------------------------------------------------------------ */
  /* Header height, used by sticky elements and the hero                 */
  /* ------------------------------------------------------------------ */
  function setHeaderHeights() {
    var header = $('site-header');
    var group = 0;
    $$('.shopify-section-group-header-group').forEach(function (el) { group += el.offsetHeight; });
    var docStyle = document.documentElement.style;
    if (header) docStyle.setProperty('--header-h', header.offsetHeight + 'px');
    if (group) docStyle.setProperty('--header-group-h', group + 'px');
  }

  /* ------------------------------------------------------------------ */
  /* Layers: mobile menu, cart drawer                                    */
  /* ------------------------------------------------------------------ */
  var lastFocus = null;

  /* The page behind an open layer does not scroll. The width of the scrollbar is
     handed to the stylesheet so nothing jumps sideways when it disappears. */
  function syncScrollLock() {
    var el = document.documentElement;
    var open = !!$('.mobile-menu.is-open, .drawer.is-open, .popup.is-open');
    if (open && !el.classList.contains('is-locked')) {
      el.style.setProperty('--scrollbar-w', Math.max(0, window.innerWidth - el.clientWidth) + 'px');
      el.classList.add('is-locked');
    } else if (!open) {
      el.classList.remove('is-locked');
    }
  }

  function openLayer(el, focusSel) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    syncScrollLock();
    var f = focusSel ? $(focusSel, el) : null;
    if (f) setTimeout(function () { f.focus(); }, 60);
  }
  function closeLayer(el) {
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    syncScrollLock();
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* Keep keyboard focus inside an open layer */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var layer = $('.mobile-menu.is-open, .drawer.is-open, .popup.is-open');
    if (!layer) return;
    var focusable = $$('a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea, summary, [tabindex]:not([tabindex="-1"])', layer)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    var active = document.activeElement;
    var known = focusable.indexOf(active) > -1;
    if (!known && !layer.contains(active)) { e.preventDefault(); first.focus(); }
    else if (e.shiftKey && (active === first || !known)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && active === last) { e.preventDefault(); first.focus(); }
  });

  function setSearch(open, trigger) {
    var panel = $('#SearchPanel');
    var header = $('site-header');
    if (!panel) return;
    panel.classList.toggle('is-open', open);
    $$('[data-action="toggle-search"]').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    if (header) {
      if (open && header.closePanels) header.closePanels();
      header.classList.toggle('has-open-layer', open);
    }
    if (open) { var input = $('input[type="search"]', panel); if (input) input.focus(); }
    else {
      var results = $('[data-search-results]', panel);
      if (results) results.hidden = true;
      if (trigger && trigger.focus) trigger.focus();
    }
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-action]');
    if (!t) return;
    var action = t.getAttribute('data-action');

    if (action === 'open-menu') { openLayer($('#MobileMenu'), '.mobile-menu__close'); }
    if (action === 'close-menu') { closeLayer($('#MobileMenu')); }
    if (action === 'toggle-search') {
      var panel = $('#SearchPanel');
      if (panel) setSearch(!panel.classList.contains('is-open'), t);
    }
    if (action === 'open-cart') {
      if (document.body.classList.contains('template-cart')) return;
      e.preventDefault();
      openLayer($('#CartDrawer'), '.drawer__close');
    }
    if (action === 'close-cart') { closeLayer($('#CartDrawer')); }
  });

  document.addEventListener('click', function (e) {
    var panel = $('#SearchPanel');
    if (!panel || !panel.classList.contains('is-open')) return;
    if (e.target.closest('#SearchPanel') || e.target.closest('[data-action="toggle-search"]')) return;
    setSearch(false);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeLayer($('#MobileMenu'));
    closeLayer($('#CartDrawer'));
    var p = $('#SearchPanel');
    if (p && p.classList.contains('is-open')) setSearch(false, $('[data-action="toggle-search"]'));
    if (window.LifeItalyPopup) window.LifeItalyPopup.close();
  });

  /* ------------------------------------------------------------------ */
  /* Toast for short messages                                            */
  /* ------------------------------------------------------------------ */
  var toastTimer;
  function toast(message) {
    var el = $('#Toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'Toast';
      el.setAttribute('role', 'alert');
      el.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:120;max-width:calc(100vw - 32px);padding:12px 18px;background:var(--color-ink);color:var(--color-paper);font-size:14px;border-radius:4px;';
      document.body.appendChild(el);
    }
    el.textContent = message;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 5000);
  }

  /* ------------------------------------------------------------------ */
  /* Cart                                                                */
  /* ------------------------------------------------------------------ */
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = !count;
    });
  }

  function refreshDrawer() {
    return fetch(root + '?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('[data-cart-drawer-inner]', doc);
        var current = $('[data-cart-drawer-inner]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      });
  }

  function refreshCart() {
    return fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        return cart;
      })
      .then(function (cart) {
        if (document.body.classList.contains('template-cart')) { window.location.reload(); return cart; }
        return refreshDrawer().then(function () { return cart; });
      });
  }

  function showFormError(form, msg) {
    if (!form.hasAttribute('data-product-form')) { toast(msg); return; }
    var box = $('[data-form-error]', form);
    if (!box) {
      box = document.createElement('p');
      box.setAttribute('data-form-error', '');
      box.setAttribute('role', 'alert');
      box.className = 'form-message form-message--error';
      form.appendChild(box);
    }
    box.textContent = msg;
  }

  function afterAdd() {
    return refreshCart().then(function () {
      if (!document.body.classList.contains('template-cart')) openLayer($('#CartDrawer'), '.drawer__close');
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-cart-form]');
    if (!form) return;
    e.preventDefault();
    var btn = $('[data-add-button]', form) || $('button[type="submit"]', form);
    if (btn && btn.getAttribute('aria-disabled') === 'true') return;
    if (btn) btn.setAttribute('aria-disabled', 'true');
    var err = $('[data-form-error]', form); if (err) err.remove();

    var fd = new FormData(form);
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
      body: fd
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) { showFormError(form, res.body.description || res.body.message || 'Could not add to the cart.'); return; }
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: res.body }));
        return afterAdd();
      })
      .catch(function () { showFormError(form, 'Network error. Please try again.'); })
      .then(function () { if (btn) btn.removeAttribute('aria-disabled'); });
  });

  /* Add several products at once (recipe pairing) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-all]');
    if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
    var items = btn.getAttribute('data-add-all').split(',')
      .filter(Boolean)
      .map(function (id) { return { id: Number(id), quantity: 1 }; });
    if (!items.length) return;
    btn.setAttribute('aria-disabled', 'true');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.body.description || res.body.message || 'Could not add to the cart.'); return; }
        return afterAdd();
      })
      .catch(function () { toast('Network error. Please try again.'); })
      .then(function () { btn.removeAttribute('aria-disabled'); });
  });

  function changeLine(line, quantity) {
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(refreshCart);
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-line-change]');
    if (!t) return;
    e.preventDefault();
    changeLine(Number(t.getAttribute('data-line')), Number(t.getAttribute('data-quantity')));
  });

  document.addEventListener('change', function (e) {
    var t = e.target.closest('[data-line-input]');
    if (!t) return;
    var q = Math.max(0, parseInt(t.value, 10) || 0);
    changeLine(Number(t.getAttribute('data-line')), q);
  });

  /* ------------------------------------------------------------------ */
  /* Country selector                                                    */
  /* ------------------------------------------------------------------ */
  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-country-select]');
    if (select && select.form) select.form.submit();
  });

  /* ------------------------------------------------------------------ */
  /* Quantity stepper (product page)                                     */
  /* ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-qty-step]');
    if (!t) return;
    var input = $('input', t.parentNode);
    if (!input) return;
    var v = (parseInt(input.value, 10) || 1) + Number(t.getAttribute('data-qty-step'));
    input.value = Math.max(1, v);
  });

  /* ------------------------------------------------------------------ */
  /* Product page: variants, gallery, tabs, buy now                      */
  /* ------------------------------------------------------------------ */
  function initProduct(section) {
    if (section.hasAttribute('data-product-ready')) return;
    var jsonEl = $('[data-product-json]', section);
    if (!jsonEl) return;
    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (err) { return; }
    section.setAttribute('data-product-ready', '');

    var form = $('[data-product-form]', section);
    var idInput = $('input[name="id"]', form);
    var priceEl = $('[data-product-price]', section);
    var availEl = $('[data-product-availability]', section);
    var addBtn = $('[data-add-button]', form);
    var buyBtn = $('[data-buy-now]', section);
    var mainImg = $('[data-main-image]', section);

    function selectedOptions() {
      var vals = [];
      $$('[data-option-group]', section).forEach(function (g) {
        var checked = $('input:checked', g);
        vals.push(checked ? checked.value : null);
      });
      return vals;
    }

    function findVariant() {
      var sel = selectedOptions();
      return variants.filter(function (v) {
        return sel.every(function (val, i) { return v.options[i] === val; });
      })[0];
    }

    function update() {
      var v = findVariant();
      if (!v) {
        if (addBtn) { addBtn.setAttribute('aria-disabled', 'true'); addBtn.querySelector('span').textContent = 'Unavailable'; }
        if (buyBtn) buyBtn.setAttribute('aria-disabled', 'true');
        return;
      }
      idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = v.price_html;
      if (availEl) {
        availEl.innerHTML = v.available
          ? '<span class="in">' + availEl.getAttribute('data-in') + '</span>'
          : '<span class="out">' + availEl.getAttribute('data-out') + '</span>';
      }
      if (addBtn) {
        if (v.available) { addBtn.removeAttribute('aria-disabled'); addBtn.querySelector('span').textContent = addBtn.getAttribute('data-label'); }
        else { addBtn.setAttribute('aria-disabled', 'true'); addBtn.querySelector('span').textContent = availEl.getAttribute('data-out'); }
      }
      if (buyBtn) { if (v.available) buyBtn.removeAttribute('aria-disabled'); else buyBtn.setAttribute('aria-disabled', 'true'); }
      if (v.image && mainImg) { mainImg.src = v.image; mainImg.removeAttribute('srcset'); }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }

    $$('[data-option-group] input', section).forEach(function (i) { i.addEventListener('change', update); });

    $$('[data-thumb]', section).forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (mainImg) { mainImg.src = btn.getAttribute('data-src'); mainImg.removeAttribute('srcset'); mainImg.alt = btn.getAttribute('data-alt') || ''; }
        $$('[data-thumb]', section).forEach(function (b) { b.setAttribute('aria-current', 'false'); });
        btn.setAttribute('aria-current', 'true');
      });
    });

    var tabs = $$('[role="tab"]', section);
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          var sel = t === tab;
          t.setAttribute('aria-selected', sel ? 'true' : 'false');
          t.setAttribute('tabindex', sel ? '0' : '-1');
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !sel;
        });
      });
      tab.addEventListener('keydown', function (ev) {
        var i = tabs.indexOf(tab);
        if (ev.key === 'ArrowRight') { tabs[(i + 1) % tabs.length].focus(); tabs[(i + 1) % tabs.length].click(); }
        if (ev.key === 'ArrowLeft') { tabs[(i - 1 + tabs.length) % tabs.length].focus(); tabs[(i - 1 + tabs.length) % tabs.length].click(); }
      });
    });

    if (buyBtn) {
      buyBtn.addEventListener('click', function () {
        if (buyBtn.getAttribute('aria-disabled') === 'true') return;
        var qty = parseInt($('input[name="quantity"]', form).value, 10) || 1;
        window.location.href = root + 'cart/' + idInput.value + ':' + qty + '?checkout';
      });
    }
  }

  /* ------------------------------------------------------------------ */
  /* Predictive search                                                   */
  /* ------------------------------------------------------------------ */
  function initSearch() {
    var input = $('[data-search-input]');
    var results = $('[data-search-results]');
    if (!input || !results || input.hasAttribute('data-search-ready')) return;
    input.setAttribute('data-search-ready', '');
    var url = input.getAttribute('data-search-url') || (root + 'search/suggest');
    var timer;
    var controller;

    function clear() {
      results.hidden = true;
      results.innerHTML = '';
      results.classList.remove('is-loading');
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      if (controller) controller.abort();
      var q = input.value.trim();
      if (q.length < 2) { clear(); return; }
      timer = setTimeout(function () {
        controller = window.AbortController ? new AbortController() : null;
        results.classList.add('is-loading');
        fetch(url + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&section_id=predictive-search', {
          credentials: 'same-origin',
          signal: controller ? controller.signal : undefined
        })
          .then(function (r) { if (!r.ok) throw new Error('search ' + r.status); return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = $('#shopify-section-predictive-search', doc);
            var markup = fresh ? fresh.innerHTML.trim() : '';
            results.innerHTML = markup;
            results.hidden = !markup;
            results.classList.remove('is-loading');
          })
          .catch(function (err) { if (!err || err.name !== 'AbortError') clear(); });
      }, 250);
    });
  }

  /* ------------------------------------------------------------------ */
  /* Newsletter popup                                                    */
  /* ------------------------------------------------------------------ */
  function initPopup() {
    var popup = $('#NewsletterPopup');
    if (!popup) return;
    var tab = $('#NewsletterTab');
    var delay = Number(popup.getAttribute('data-delay')) * 1000 || 6000;
    var days = Number(popup.getAttribute('data-days'));
    if (!(days >= 0)) days = 7;
    var hasResult = popup.getAttribute('data-has-result') === 'true';
    var success = popup.getAttribute('data-success') === 'true';
    var subscribed = storageGet('localStorage', 'li-popup-subscribed') === '1';
    var seen = storageGet('sessionStorage', 'li-popup-seen') === '1';
    var closedAt = Number(storageGet('localStorage', 'li-popup-closed')) || 0;
    var closedRecently = closedAt > 0 && Date.now() - closedAt < days * 864e5;
    var inEditor = window.Shopify && window.Shopify.designMode;
    var returnFocus = null;

    function showTab() { if (tab && !(success || subscribed)) tab.classList.add('is-visible'); }

    function open(fromVisitor) {
      if (popup.classList.contains('is-open')) return;
      returnFocus = document.activeElement;
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      syncScrollLock();
      if (tab) tab.classList.remove('is-visible');
      storageSet('sessionStorage', 'li-popup-seen', '1');
      /* When it opens by itself the field is not focused, so phones do not raise the keyboard */
      var target = fromVisitor === true ? $('input:not([type="hidden"])', popup) : $('.popup__box', popup);
      if (target) target.focus({ preventScroll: true });
    }
    function close() {
      if (!popup.classList.contains('is-open')) return;
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      syncScrollLock();
      if (!inEditor) storageSet('localStorage', 'li-popup-closed', String(Date.now()));
      showTab();
      if (returnFocus && returnFocus.focus && document.body.contains(returnFocus)) returnFocus.focus({ preventScroll: true });
    }
    window.LifeItalyPopup = { open: open, close: close };

    $$('[data-popup-close]', popup).forEach(function (b) { b.addEventListener('click', close); });
    if (tab) tab.addEventListener('click', function () { open(true); });

    /* In the theme editor the popup opens only while its section is selected */
    var section = popup.closest('.shopify-section');
    if (inEditor && section) {
      section.addEventListener('shopify:section:select', function () { open(); });
      section.addEventListener('shopify:section:deselect', close);
    }

    if (success) { storageSet('localStorage', 'li-popup-subscribed', '1'); open(); return; }
    if (hasResult) { open(true); return; }
    if (subscribed || inEditor) return;
    if (seen || closedRecently) { showTab(); return; }

    /* Wait for a quiet moment: not over the cookie banner, the menu, the cart or the search */
    function busy() {
      var banner = document.getElementById('shopify-pc__banner');
      if (banner && banner.getClientRects().length) return true;
      return !!$('.drawer.is-open, .mobile-menu.is-open, .search-panel.is-open, .site-header.has-open-layer');
    }
    (function wait(ms) {
      setTimeout(function () { if (busy()) wait(1500); else open(); }, ms);
    })(delay);
  }

  /* ------------------------------------------------------------------ */
  /* Components                                                          */
  /* ------------------------------------------------------------------ */
  function define(name, ctor) {
    if (window.customElements && !customElements.get(name)) customElements.define(name, ctor);
  }

  /* Header: navigation panels */
  function SiteHeader() { return Reflect.construct(HTMLElement, [], SiteHeader); }
  SiteHeader.prototype = Object.create(HTMLElement.prototype);
  SiteHeader.prototype.constructor = SiteHeader;
  SiteHeader.prototype.connectedCallback = function () {
    var self = this;
    this.triggers = $$('[data-nav-trigger]', this);
    this.current = null;
    this.timer = null;
    var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

    /* The dimmed page behind an open panel is an element of its own: the pointer can
       leave the header onto it, and a click or tap on it closes whatever is open. */
    this.backdrop = $('[data-header-backdrop]', this);
    if (!this.backdrop) {
      this.backdrop = document.createElement('div');
      this.backdrop.className = 'site-header__backdrop';
      this.backdrop.setAttribute('data-header-backdrop', '');
      this.appendChild(this.backdrop);
    }
    function closeSoon() {
      clearTimeout(self.timer);
      self.timer = setTimeout(function () { self.closePanels(); }, 180);
    }

    /* A panel opened by hovering closes when the pointer leaves it. One opened from the
       keyboard or by a tap stays open, wherever the pointer happens to rest on the page. */
    this.byHover = false;
    this.triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        /* With a mouse the panel is already open from the hover: a click must not close it again.
           From the keyboard or on a touch screen the same control opens and closes it. */
        var mouseClick = e.detail > 0 && canHover.matches;
        if (self.current !== trigger) { self.openPanel(trigger); self.byHover = mouseClick; }
        else if (!mouseClick) self.closePanels();
      });
      trigger.addEventListener('mouseenter', function () {
        if (!canHover.matches) return;
        clearTimeout(self.timer);
        if (self.current !== trigger) { self.openPanel(trigger); self.byHover = true; }
      });
    });
    $$('.site-nav__link:not([data-nav-trigger])', this).forEach(function (link) {
      link.addEventListener('mouseenter', function () { if (canHover.matches) self.closePanels(); });
    });
    this.addEventListener('mouseover', function (e) {
      if (!canHover.matches || !self.byHover) return;
      if (e.target === self.backdrop) closeSoon(); else clearTimeout(self.timer);
    });
    this.addEventListener('mouseleave', function () { if (canHover.matches && self.byHover) closeSoon(); });
    this.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.current) { var t = self.current; self.closePanels(); t.focus(); }
    });
    this.addEventListener('focusout', function (e) {
      if (self.current && e.relatedTarget && !self.contains(e.relatedTarget)) self.closePanels();
    });
    this.onDocClick = function (e) {
      if (self.current && (e.target === self.backdrop || !self.contains(e.target))) self.closePanels();
    };
    document.addEventListener('click', this.onDocClick);

    setHeaderHeights();
    if (window.ResizeObserver) {
      this.observer = new ResizeObserver(setHeaderHeights);
      this.observer.observe(this);
    }
  };
  SiteHeader.prototype.disconnectedCallback = function () {
    document.removeEventListener('click', this.onDocClick);
    if (this.observer) this.observer.disconnect();
  };
  SiteHeader.prototype.openPanel = function (trigger) {
    if (this.current === trigger) return;
    this.closePanels();
    var panel = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!panel) return;
    var search = $('#SearchPanel');
    if (search && search.classList.contains('is-open')) setSearch(false);
    panel.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    this.current = trigger;
    this.classList.add('has-open-layer');
  };
  SiteHeader.prototype.closePanels = function () {
    if (!this.current) return;
    var panel = document.getElementById(this.current.getAttribute('aria-controls'));
    if (panel) panel.hidden = true;
    this.current.setAttribute('aria-expanded', 'false');
    this.current = null;
    var search = $('#SearchPanel');
    if (!search || !search.classList.contains('is-open')) this.classList.remove('has-open-layer');
  };
  define('site-header', SiteHeader);

  /* Announcement bar: rotates messages */
  function AnnouncementBar() { return Reflect.construct(HTMLElement, [], AnnouncementBar); }
  AnnouncementBar.prototype = Object.create(HTMLElement.prototype);
  AnnouncementBar.prototype.constructor = AnnouncementBar;
  AnnouncementBar.prototype.connectedCallback = function () {
    var self = this;
    this.items = $$('[data-announcement]', this);
    this.index = 0;
    if (this.items.length < 2) return;
    this.delay = (Number(this.getAttribute('data-interval')) || 5) * 1000;
    this.addEventListener('mouseenter', function () { self.stop(); });
    this.addEventListener('mouseleave', function () { self.start(); });
    this.addEventListener('focusin', function () { self.stop(); });
    this.addEventListener('focusout', function () { self.start(); });
    this.addEventListener('shopify:block:select', function (e) {
      self.stop();
      self.locked = true;
      self.show(self.items.indexOf(e.target));
    });
    this.addEventListener('shopify:block:deselect', function () { self.locked = false; self.start(); });
    this.start();
  };
  AnnouncementBar.prototype.disconnectedCallback = function () { this.stop(); };
  AnnouncementBar.prototype.show = function (i) {
    if (i < 0) return;
    this.index = i;
    this.items.forEach(function (el, n) {
      el.classList.toggle('is-active', n === i);
      if (n === i) el.removeAttribute('aria-hidden'); else el.setAttribute('aria-hidden', 'true');
    });
  };
  AnnouncementBar.prototype.start = function () {
    var self = this;
    if (this.locked || reduceMotion.matches || this.items.length < 2) return;
    this.stop();
    this.timer = setInterval(function () { self.show((self.index + 1) % self.items.length); }, this.delay);
  };
  AnnouncementBar.prototype.stop = function () { clearInterval(this.timer); };
  define('announcement-bar', AnnouncementBar);

  /* Hero: slides */
  function HeroSlideshow() { return Reflect.construct(HTMLElement, [], HeroSlideshow); }
  HeroSlideshow.prototype = Object.create(HTMLElement.prototype);
  HeroSlideshow.prototype.constructor = HeroSlideshow;
  HeroSlideshow.prototype.connectedCallback = function () {
    var self = this;
    this.slides = $$('[data-slide]', this);
    this.index = 0;
    if (this.slides.length < 2) return;
    this.autoplay = this.getAttribute('data-autoplay') === 'true';
    this.delay = (Number(this.getAttribute('data-interval')) || 6) * 1000;
    this.paused = false;
    this.slides.forEach(function (s, n) { s.inert = n !== 0; });

    this.addEventListener('click', function (e) {
      var prev = e.target.closest('[data-hero-prev]');
      var next = e.target.closest('[data-hero-next]');
      var pause = e.target.closest('[data-hero-pause]');
      if (prev) self.go(self.index - 1, '[data-hero-prev]');
      if (next) self.go(self.index + 1, '[data-hero-next]');
      /* After a manual change the countdown starts again, so the new slide gets its full time */
      if ((prev || next) && !self.paused) self.start();
      if (pause) {
        self.paused = !self.paused;
        $$('[data-hero-pause]', self).forEach(function (b) { b.setAttribute('aria-pressed', self.paused ? 'true' : 'false'); });
        if (self.paused) self.stop(); else self.start();
      }
    });
    /* In right-to-left pages the next slide lies to the left */
    var forward = function () { return isRtl(self) ? -1 : 1; };
    this.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') self.go(self.index - forward());
      if (e.key === 'ArrowRight') self.go(self.index + forward());
    });
    var startX = null;
    this.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    this.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      startX = null;
      if (Math.abs(dx) > 48) self.go(self.index + (dx < 0 ? forward() : -forward()));
    }, { passive: true });
    this.addEventListener('mouseenter', function () { self.stop(); });
    this.addEventListener('mouseleave', function () { self.start(); });
    this.addEventListener('focusin', function () { self.stop(); });
    this.addEventListener('focusout', function () { self.start(); });
    this.addEventListener('shopify:block:select', function (e) {
      self.locked = true;
      self.stop();
      self.go(self.slides.indexOf(e.target));
    });
    this.addEventListener('shopify:block:deselect', function () { self.locked = false; self.start(); });
    this.start();
  };
  HeroSlideshow.prototype.disconnectedCallback = function () { this.stop(); };
  HeroSlideshow.prototype.go = function (i, refocus) {
    var count = this.slides.length;
    if (i === -1 && count === 0) return;
    var n = ((i % count) + count) % count;
    this.index = n;
    this.slides.forEach(function (s, k) {
      var active = k === n;
      s.classList.toggle('is-active', active);
      s.inert = !active;
      if (active) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
    });
    if (refocus) { var f = $(refocus, this.slides[n]); if (f) f.focus(); }
  };
  HeroSlideshow.prototype.start = function () {
    var self = this;
    if (!this.autoplay || this.paused || this.locked || reduceMotion.matches) return;
    this.stop();
    this.timer = setInterval(function () { self.go(self.index + 1); }, this.delay);
  };
  HeroSlideshow.prototype.stop = function () { clearInterval(this.timer); };
  define('hero-slideshow', HeroSlideshow);

  /* Hero: several products in one photo. On mobile the arrow shows the next card. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-spot-next]');
    if (!btn) return;
    var wrap = btn.closest('[data-spots]');
    var cards = $$('[data-spot]', wrap);
    var at = cards.findIndex(function (c) { return c.classList.contains('is-current'); });
    var n = (at + 1) % cards.length;
    cards.forEach(function (c, k) { c.classList.toggle('is-current', k === n); });
  });

  /* Carousel: a scrolling row with previous and next buttons */
  function ScrollCarousel() { return Reflect.construct(HTMLElement, [], ScrollCarousel); }
  ScrollCarousel.prototype = Object.create(HTMLElement.prototype);
  ScrollCarousel.prototype.constructor = ScrollCarousel;
  ScrollCarousel.prototype.connectedCallback = function () {
    var self = this;
    this.track = $('[data-carousel-track]', this);
    this.prev = $('[data-carousel-prev]', this);
    this.next = $('[data-carousel-next]', this);
    if (!this.track || !this.prev || !this.next) return;
    var ticking = false;
    this.update = function () {
      var max = self.track.scrollWidth - self.track.clientWidth - 2;
      /* In right-to-left pages scrollLeft runs from 0 down to negative values */
      var pos = Math.abs(self.track.scrollLeft);
      self.prev.disabled = pos <= 2;
      self.next.disabled = pos >= max;
      var nav = self.prev.parentNode;
      if (nav) nav.style.visibility = max <= 0 ? 'hidden' : '';
    };
    function step() {
      var first = self.track.firstElementChild;
      var gap = parseFloat(getComputedStyle(self.track).columnGap) || 0;
      var item = first ? first.getBoundingClientRect().width + gap : self.track.clientWidth;
      var visible = Math.max(1, Math.floor((self.track.clientWidth + gap) / item));
      return item * visible;
    }
    function sign() { return isRtl(self.track) ? -1 : 1; }
    this.prev.addEventListener('click', function () { self.track.scrollBy({ left: -step() * sign(), behavior: reduceMotion.matches ? 'auto' : 'smooth' }); });
    this.next.addEventListener('click', function () { self.track.scrollBy({ left: step() * sign(), behavior: reduceMotion.matches ? 'auto' : 'smooth' }); });
    this.track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { self.update(); ticking = false; });
    }, { passive: true });
    if (window.ResizeObserver) {
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
    }
    this.update();
  };
  ScrollCarousel.prototype.disconnectedCallback = function () { if (this.observer) this.observer.disconnect(); };
  define('scroll-carousel', ScrollCarousel);

  /* Category index: the photo follows the row under the pointer */
  function PantryIndex() { return Reflect.construct(HTMLElement, [], PantryIndex); }
  PantryIndex.prototype = Object.create(HTMLElement.prototype);
  PantryIndex.prototype.constructor = PantryIndex;
  PantryIndex.prototype.connectedCallback = function () {
    var rows = $$('[data-pantry-row]', this);
    var images = $$('[data-pantry-image]', this);
    function activate(id) {
      rows.forEach(function (r) { r.classList.toggle('is-active', r.getAttribute('data-pantry-row') === id); });
      images.forEach(function (im) { im.classList.toggle('is-active', im.getAttribute('data-pantry-image') === id); });
    }
    rows.forEach(function (row) {
      var id = row.getAttribute('data-pantry-row');
      row.addEventListener('mouseenter', function () { activate(id); });
      row.addEventListener('focus', function () { activate(id); });
    });
    this.addEventListener('shopify:block:select', function (e) {
      var row = $('[data-pantry-row]', e.target);
      if (row) activate(row.getAttribute('data-pantry-row'));
    });
  };
  define('pantry-index', PantryIndex);

  /* ------------------------------------------------------------------ */
  /* Image banner: the round label follows the pointer                   */
  /* ------------------------------------------------------------------ */
  var cursorArea = null;
  var cursorEvent = null;
  var cursorFrame = 0;
  function placeCursorLabel() {
    cursorFrame = 0;
    var e = cursorEvent;
    var area = e.target && e.target.closest ? e.target.closest('[data-cursor-area]') : null;
    if (!area) { cursorArea = null; return; }
    var box = area.getBoundingClientRect();
    var entering = area !== cursorArea;
    cursorArea = area;
    /* On the first move over a photo the label is put under the pointer at once, so it does not glide in from the centre */
    if (entering) area.classList.add('is-placing');
    area.style.setProperty('--cx', (e.clientX - box.left) + 'px');
    area.style.setProperty('--cy', (e.clientY - box.top) + 'px');
    area.classList.add('has-pointer');
    if (entering) { void area.offsetWidth; area.classList.remove('is-placing'); }
  }
  document.addEventListener('pointermove', function (e) {
    if (e.pointerType === 'touch' || reduceMotion.matches) return;
    cursorEvent = e;
    if (!cursorFrame) cursorFrame = requestAnimationFrame(placeCursorLabel);
  }, { passive: true });

  /* ------------------------------------------------------------------ */
  /* Start                                                               */
  /* ------------------------------------------------------------------ */
  /* Category pills scroll sideways on small screens: start with the current one in view */
  function showActivePill(scope) {
    $$('.category-pills__list', scope).forEach(function (list) {
      var active = $('.is-active', list);
      if (!active) return;
      var box = list.getBoundingClientRect();
      var pill = active.getBoundingClientRect();
      list.scrollLeft += (pill.left + pill.width / 2) - (box.left + box.width / 2);
    });
  }

  function init(scope) {
    $$('[data-product-section]', scope).forEach(initProduct);
    showActivePill(scope);
    initSearch();
    setHeaderHeights();
  }

  init(document);
  initPopup();
  window.addEventListener('resize', setHeaderHeights);
  /* Once fonts and images are in, sizes are final: measure again */
  window.addEventListener('load', function () { setHeaderHeights(); showActivePill(document); });

  /* Theme editor: refresh what was re-rendered, and show the cart while its section is selected */
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
    if ($('#NewsletterPopup', e.target)) initPopup();
  });
  document.addEventListener('shopify:section:select', function (e) {
    if ($('#CartDrawer', e.target)) openLayer($('#CartDrawer'));
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if ($('#CartDrawer', e.target)) closeLayer($('#CartDrawer'));
  });
  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target.closest ? e.target.closest('details') : null;
    if (item) item.open = true;
  });
})();
